// Splits the header wordmark so the second half can be toned down:
// ESSENTIALS + BASE. Purely visual - the accessible name is unchanged
// because the text content stays identical.
(function () {
  function splitMark() {
    var el = document.querySelector('.header-logo .header-logo__image-container');
    if (!el || el.querySelector('.tpx-mark-b') || el.querySelector('img')) return;

    var raw = (el.textContent || '').trim();
    if (!raw) return;

    // Split on the documented brand seam; bail out if the name ever changes.
    var seam = raw.toLowerCase().indexOf('base');
    if (seam < 1) return;

    var head = raw.slice(0, seam);
    var tail = raw.slice(seam);
    el.textContent = '';
    el.appendChild(document.createTextNode(head));
    var span = document.createElement('span');
    span.className = 'tpx-mark-b';
    span.textContent = tail;
    el.appendChild(span);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', splitMark);
  } else {
    splitMark();
  }
})();
